/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DynamicPropsEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    DynamicPropertiesEditService: JS5Object,
    BreadcrumbService: JS5Object,
    NotificationService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
    $timeout: JS5Function
) {

    //===================//
    // Template Response //
    //===================//

    this.isCreatingProperty = () => {
        return !DynamicPropertiesEditService.originalPropertyValue;
    };

    const onSaveClicked = () => {
        let propertyNamePath = encodeURIComponent(this.editData.name);
        this.loadingIndicator.show = true;
        DynamicPropertiesEditService.saveEditData().then(() => {
            $location.search('propertyName', propertyNamePath);
            return getData();
        }, (rejectionReason: string) => {
            NotificationService.createFailureNotification(rejectionReason, '');
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') && _.get(this.editorForm, '$valid'),
            onClick: onSaveClicked
        }, {
            label: 'Revert',
            enabled: () => this.isCreatingProperty() || !_.get(this, 'editorForm.$pristine'),
            onClick: DynamicPropertiesEditService.revertEditData
        }, {
            label: 'Close',
            enabled: () => true,
            onClick: DynamicPropertiesEditService.exitEdit
        }];


    //=================//
    // Lifecycle Hooks //
    //=================//

    const getData = () => {
        let propertyName = decodeURIComponent(_.get($location.search(), 'propertyName', ''));
        this.loadingIndicator.show = true;
        return DynamicPropertiesEditService.getEditData(propertyName)
            .then((editData: JS5Object) => {
                DynamicPropertiesEditService.originalPropertyValue = _.cloneDeep(editData.value);
                DynamicPropertiesEditService.editData = editData;
                this.editData = editData;
            })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    this.$onInit = () => {
        BreadcrumbService.editService = DynamicPropertiesEditService;
        SidebarService.editService = DynamicPropertiesEditService;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (PermissionsService.isAdmin()) {
            getData().then(() => {
                let breadcrumbName: string;
                if (this.editData.value) {
                    breadcrumbName = 'Edit Dynamic Property';
                } else {
                    breadcrumbName = 'Create Dynamic Property';
                    this.editData.value = '';
                }
                BreadcrumbService.addBreadcrumb({
                    name: breadcrumbName,
                    location: '/system/properties/search',
                    params: {tab: 'DynamicProps'}
                });
            });

        } else {
            $location.url('/login');
        }
    };

    this.$postLink = () => {
        $timeout(() => {
            DynamicPropertiesEditService.editorForm = this.editorForm;
        })
    };

    this.$onDestroy = () => {
        DynamicPropertiesEditService.originalEditData = null;
        DynamicPropertiesEditService.viewData = null;
        DynamicPropertiesEditService.editorForm = null;
        BreadcrumbService.editService = null;
        SidebarService.editService = null;
    };
}


angular.module('prism-ui.system').component('dynamicPropsEditView', {
    templateUrl: 'system/dynamicProperties/editor/dynamic-property-edit-view-template.html',
    controller: DynamicPropsEditViewController,
    bindings: {}
});
